export const formatPhone = (phone) => {
  if (!phone) return

  const ddd = `(${phone.substr(0, 2)})`
  const _phone = `${phone.length === 11 ? phone.substr(2, 5) : phone.substr(2, 4)}-${phone.substr(7)}`

  return `${ddd} ${_phone}`
}
